import React from 'react';
import { __ } from '@wordpress/i18n';

const Header = ( { currencies, prevCurrencies, saveCurrencies } ) => {
	return (
		<div className="cmgf-wrapper__sticky">
			<span className="cmgf-wrapper__span">
				<button
					type="button"
					onClick={ saveCurrencies }
					className={
						Array.isArray( prevCurrencies ) &&
						Array.isArray( currencies ) &&
						JSON.stringify( currencies ) !==
							JSON.stringify( prevCurrencies )
							? 'cmgf-wrapper-button cmgf-wrapper-button--changed'
							: 'cmgf-wrapper-button'
					}
				>
					{ __( 'Save Changes', 'currency-manager-for-gravity-forms' ) }
				</button>
			</span>
		</div>
	);
};
export default Header;
